exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-box{\r\n  width: 320px;\r\n}\r\n\r\nimg {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin: 5px;\r\n}\r\n\r\n.flagWrapper {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: column;\r\n      flex-direction: column;\r\n}\r\n\r\n.dropdown-menu {\r\n  min-width: 0px;\r\n}\r\n\r\n.languageButton {\r\n  border-radius: 50%;\r\n  border: none;\r\n  padding: 0;\r\n}\r\n\r\n.languageHeaderWrapper {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: justify;\r\n      justify-content: space-between;\r\n  -ms-flex-align: baseline;\r\n      align-items: baseline;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.login-box-msg {\r\n  padding: 0 10px 0 0;\r\n  font-size: 1.8rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/login/login-view.component.css
// module id = ../../../../../src/app/controllers/login/login-view.component.css
// module chunks = main